module.exports = __webpack_public_path__ + "static/img/aboutus_icon_position_2@2x.c8d61af.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/about/aboutus_icon_position_2@2x.png
// module id = No0x
// module chunks = 0